// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  background-color: #f2f2f2;
  color: #606060;
  box-shadow: 1px 1px #eaeaea; }

.navbar-nav {
  display: flex;
  justify-content: space-around; }

.navbar-item.active .nav-link {
  color: #4330ff !important; }

.navbar-brand-mobile {
  display: none; }

.navbar-item {
  position: relative; }

.logout-button {
  position: relative;
  width: 60px; }

.data-count[data-count]:after {
  position: absolute;
  top: 5%;
  content: attr(data-count);
  font-size: .5em;
  padding: .6em;
  border-radius: 999px;
  line-height: .75em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold; }

.nav-link {
  color: #606060; }

.debug-json {
  display: none; }

.page-title-nav {
  background-color: #f2f2f2;
  border-top: 2px solid #c0c0c0; }
  .page-title-nav .back-button i {
    color: #4330ff;
    vertical-align: sub; }
  .page-title-nav .back-button h6 {
    color: #4330ff;
    display: inline-block; }
  .page-title-nav .page-title-name {
    text-align: center; }
    .page-title-nav .page-title-name h6 {
      margin-bottom: 0px;
      padding-top: 7px;
      padding-bottom: 7px; }

@media only screen and (max-width: 992px) {
  .navbar-brand-mobile {
    display: block; }
  a.navbar-brand {
    display: none; }
  .navbar-item {
    width: 120px; } }

@media only screen and (min-width: 992px) {
  .navbar-expand-lg .navbar-nav {
    width: 100%; } }
`, "",{"version":3,"sources":["webpack://./src/components/Layout/layout.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B,EAAE;;AAE/B;EACE,aAAa;EACb,6BAA6B,EAAE;;AAEjC;EACE,yBAAyB,EAAE;;AAE7B;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,WAAW,EAAE;;AAEf;EACE,kBAAkB;EAClB,OAAO;EACP,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,aAAa,EAAE;;AAEjB;EACE,yBAAyB;EACzB,6BAA6B,EAAE;EAC/B;IACE,cAAc;IACd,mBAAmB,EAAE;EACvB;IACE,cAAc;IACd,qBAAqB,EAAE;EACzB;IACE,kBAAkB,EAAE;IACpB;MACE,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB,EAAE;;AAE3B;EACE;IACE,cAAc,EAAE;EAClB;IACE,aAAa,EAAE;EACjB;IACE,YAAY,EAAE,EAAE;;AAEpB;EACE;IACE,WAAW,EAAE,EAAE","sourcesContent":["nav {\n  background-color: #f2f2f2;\n  color: #606060;\n  box-shadow: 1px 1px #eaeaea; }\n\n.navbar-nav {\n  display: flex;\n  justify-content: space-around; }\n\n.navbar-item.active .nav-link {\n  color: #4330ff !important; }\n\n.navbar-brand-mobile {\n  display: none; }\n\n.navbar-item {\n  position: relative; }\n\n.logout-button {\n  position: relative;\n  width: 60px; }\n\n.data-count[data-count]:after {\n  position: absolute;\n  top: 5%;\n  content: attr(data-count);\n  font-size: .5em;\n  padding: .6em;\n  border-radius: 999px;\n  line-height: .75em;\n  color: white;\n  background: rgba(255, 0, 0, 0.85);\n  text-align: center;\n  min-width: 2em;\n  font-weight: bold; }\n\n.nav-link {\n  color: #606060; }\n\n.debug-json {\n  display: none; }\n\n.page-title-nav {\n  background-color: #f2f2f2;\n  border-top: 2px solid #c0c0c0; }\n  .page-title-nav .back-button i {\n    color: #4330ff;\n    vertical-align: sub; }\n  .page-title-nav .back-button h6 {\n    color: #4330ff;\n    display: inline-block; }\n  .page-title-nav .page-title-name {\n    text-align: center; }\n    .page-title-nav .page-title-name h6 {\n      margin-bottom: 0px;\n      padding-top: 7px;\n      padding-bottom: 7px; }\n\n@media only screen and (max-width: 992px) {\n  .navbar-brand-mobile {\n    display: block; }\n  a.navbar-brand {\n    display: none; }\n  .navbar-item {\n    width: 120px; } }\n\n@media only screen and (min-width: 992px) {\n  .navbar-expand-lg .navbar-nav {\n    width: 100%; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
